<app-page-breadcrumb [pageTitle]="'app.label.profile' | translate" />
<div class="space-y-8">
  <div><app-user-info-card/></div>
  <div><app-user-address-card/></div>
</div>
